<template>
  <button
    :class="[
      'atc-button',
      {
        'is-big': isFullScreen || isBubbleAndLargeScreen || isEmbedMobile,
        'carousel-fullscreen-horizontal-atc-button-wrapper-preview':
          isCarousel && isFullScreen && isHorizontalSwipe && isInPreview,
      },
    ]"
    @click="$emit('click')"
  >
    <slot name="left-arrow"></slot>
    <div
      :class="[
        'button-with-image',
        {
          'is-big': isFullScreen || isBubbleAndLargeScreen || isEmbedMobile || (isEmbed && isLandscape),
          'is-inline':
            !isFullScreen && !isBubbleAndLargeScreen && !isEmbedMobile,
          'button-with-img-has-arrows':
            (isFullScreen && hasArrows) ||
            (isBubbleAndLargeScreen && hasArrows) ||
            (isEmbedMobile && hasArrows),
          'inline-button-with-img-has-arrows':
            !isFullScreen &&
            hasArrows &&
            !isBubbleAndLargeScreen &&
            !isEmbedMobile,
            'inline-with-arrow': !isFullScreen && !isBubbleAndLargeScreen && !isEmbedMobile && isTimeHealth
        },
      ]"
      :style="buttonWithImageStyles"
    >
      <div
        class="product-image"
        :class="{
          'inline-product-image': !isFullScreen,
          'image-wrapper-with-margin':
            format.productCardOptions &&
            format.productCardOptions.style === 'margin',
            'inline-with-arrow': !isFullScreen && !isBubbleAndLargeScreen && !isEmbedMobile && isTimeHealth
        }"
      >
        <div
          v-if="isTimeHealth && !isFullScreen"
          class="arrow-container"
          :style="buttonWithImageStyles"
        >
          <ArrowDown class="product-arrow" />
        </div>
        <img
          class="product-image"
          :class="{
            'inline-product-image': !isFullScreen,
            'image-with-margin':
              isFullScreen || (isEmbed && (isLandscape || isSquare)) &&
              format.productCardOptions &&
              format.productCardOptions.style === 'margin',
          }"
          :src="resizedImageUrl || product.imageUrl"
          alt="product"
          draggable="false"
        />
        <BagIcon v-if="!product.imageUrl" />
      </div>
      <div
        v-if="isFullScreen || isBubbleAndLargeScreen || isEmbedMobile"
        class="product-information"
        :class="{ 'product-information-has-arrows': hasArrows }"
      >
        <p class="name" :style="textStyles">
          {{ decodeText(product.name) || $t("player.atcButton.yourProduct") }}
        </p>
        <p class="price" :style="textStyles">
          {{ displayCurrency(currency, product.variants[0].price) }}
        </p>
      </div>
    </div>
    <slot name="right-arrow"></slot>
  </button>
</template>
<script>
import BagIcon from "@/assets/bag-icon.svg";
import { displayCurrency, decodeText } from "@/utils/utils";
import { mapGetters } from "vuex";
import { resizeImage } from "@/utils/resizeImage";
import ArrowDown from "@/assets/arrow-down.svg";

export default {
  components: {
    BagIcon,
    ArrowDown,
  },
  data() {
    return {
      displayCurrency,
      resizedImageUrl: "",
      decodeText,
    };
  },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    hasArrows: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("playerSite", ["currency"]),
    ...mapGetters("playerCampaign", [
      "isFullScreen",
      "format",
      "isBubble",
      "isPopup",
      "isEmbed",
      "isCarousel",
      "isHorizontalSwipe",
    ]),
    ...mapGetters("player", ["isMobile", "isInPreview"]),
    ...mapGetters("videos", ["isLandscape", "isSquare"]),
    parentUrl() {
      return this.isInPreview ? "#" : document.referrer + "/cart";
    },
    buttonWithImageStyles() {
      const defaultBackgroundColor = "#ffffff66";
      const defaultColor = "#FFFFFF";
      const backgroundColor =
        this.format.productCardOptions?.backgroundColor ||
        defaultBackgroundColor;
      const color = this.format.productCardOptions?.color || defaultColor;
      return {
        backgroundColor,
        color,
      };
    },
    textStyles() {
      const isBold = this.format.productCardOptions?.isBold ? "bold" : "normal";
      const isItalic = this.format.productCardOptions?.isItalic
        ? "italic"
        : "normal";
      const isUnderlined = this.format.productCardOptions?.isUnderlined
        ? "underline"
        : "none";
      return {
        fontWeight: isBold,
        fontStyle: isItalic,
        textDecoration: isUnderlined,
      };
    },
    isBubbleAndLargeScreen() {
      return (
        (this.isBubble || this.isEmbed) &&
        !this.isInPreview &&
        window.innerWidth >= 400
      );
    },
    isEmbedMobile() {
      return this.isEmbed && this.isMobile && !this.isInPreview;
    },
    isTimeHealth() {
      return this.product.siteId === "e537e73f-d665-49aa-9030-d7cc9056a08b"
    }
  },
  watch: {
    "product.imageUrl": {
      handler(newUrl) {
        if (newUrl) this.updateImage(newUrl);
      },
      immediate: true,
    },
  },
  methods: {
    async updateImage(url) {
      try {
        this.resizedImageUrl = await resizeImage(url);
      } catch (error) {
        console.error("Image resizing failed", error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.atc-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.has-shopped.atc-button {
  background: black;
}
.button-with-image {
  background-color: rgba(255, 255, 255, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  border-radius: 5px;
  color: rgba(255, 255, 255, 0.8);
  &.is-big {
    font-size: 18px;
    max-width: 270px;
    flex-direction: initial;
    .product-image {
      height: 70px;
      width: 70px;
    }
    svg {
      background: white;
    }
  }
  svg {
    padding: 8px 0;
    border-radius: 5px;
    fill: #585858;
    transform: scale(1.5);
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.6);
    transition: background-color 0.3s ease-in-out;
  }
}
.image-wrapper-with-margin {
  height: 70px !important;
  width: 70px !important;
}
.image-with-margin {
  height: 60px !important;
  width: 60px !important;
  margin: 5px;
}
.product-information {
  font-family: "Roboto", sans-serif;
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  height: 70px;
  justify-content: space-evenly;
  align-items: flex-start;
  font-size: 16px;
  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 18px;
    max-height: 40px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: start;
    width: 180px;
  }
  .price {
    font-weight: 500;
  }
}
.product-image {
  height: 50px;
  width: 60px;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 0 0 5px 5px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  object-fit: cover;
  object-position: top;
}
.is-big .product-image {
  border-radius: 5px 0 0 5px;
}
.is-big .image-with-margin {
  border-radius: 5px !important;
}
.is-inline {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 4px;
  padding: 3px;
  width: 60px;
  height: 60px;
  box-sizing: border-box;
  &:hover {
    background-color: $light-grey;
  }
}
.inline-product-image {
  width: 54px;
  height: 54px;
  border-radius: 2px;
  align-items: flex-end;
}
.button-with-img-has-arrows {
  max-width: 90% !important;
}
.product-information-has-arrows {
  margin-left: 8px;
  width: calc(100% - 82px);
  .name {
    width: 200px;
    max-width: 100%;
  }
}
.inline-button-with-img-has-arrows {
  margin: 0 12px;
}
.carousel-fullscreen-horizontal-atc-button-wrapper-preview {
  scale: 0.85;
}
.arrow-container {
  z-index: 100;
  height: 5px;
  width: 60px;
  position: absolute;
  top: -5px;
  display: flex;
  justify-content: center;
}
.product-arrow {
  transform: rotate(180deg) !important;
  path {
    fill: black;
  }
}
.inline-with-arrow {
  height: 75px;
}
</style>
